import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";

interface IProps {
    open: boolean;
    singleData: any;
    branchInvoiceID: number,
    onHide: () => void;
    loadTableData: () => void;
    toast: any;
}

interface IData {
    paymentStatus: string;
    receivedAmount: number;
}

const Payment_Status = [
    { name: "-- SELECT --", value: null },
    { name: "Pending", value: "Pending" },
    { name: "Paid", value: "Paid" },
];

const schema = yup.object({
    paymentStatus: yup.string().required("Status is required"),
    receivedAmount: yup.number().when('paymentStatus', val => {
        return (val === "Partial Payment") ?
            yup.number().required("Received Amount is required").typeError("Received Amount is required") :
            yup.number().nullable();
    }),
});

export const ConsultantWisePaymentUpdate = (props: IProps) => {
    const [showRP, setShowRP] = useState(false);
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IData>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const onHide = () => {
        setShowRP(false);
        props.onHide();
    }

    const onSubmit = async (data: IData) => {
        let body = {
            id: props.singleData.id,
            branch_Invoice_ID: props.singleData.branch_Invoice_ID,
            PaymentStatus: data.paymentStatus,
            ReceivedAmount: data.paymentStatus === "Partial Payment" ? data.receivedAmount : props.singleData.branchInvoiceAmount
        };
        setLoading(true);

        const response = await Fetch("InvoiceTracking/updateGenerateBranchInvoiceConsultantInvoiceByID", "PUT", body, null, props.toast);
        if (response) {
            setLoading(false);
            props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Updated Successfully' });
            props.loadTableData();
            onHide();
        } else {
            setLoading(false);
            props.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to Updated' });
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === 'paymentStatus') {
                if (value.paymentStatus === "Partial Payment") {
                    setShowRP(true);
                } else setShowRP(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, showRP]);

    useEffect(() => {
        if (props.open) {
            if (props.singleData.branch_Incentive_PaymentStatus) {
                let newData = {
                    paymentStatus: props.singleData.branch_Incentive_PaymentStatus,
                    receivedAmount: props.singleData.receivedAmount || props.singleData.branchInvoiceAmount
                };
                if (newData.paymentStatus === "Partial Payment") {
                    setShowRP(true);
                }
                reset(newData);
            } else {
                reset({
                    paymentStatus: "Paid",
                    receivedAmount: props.singleData.receivedAmount || props.singleData.branchInvoiceAmount
                });
            }
        }
    }, [props.open]);
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Consultant Wise Incentive" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={1} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} />
                {showRP && <JVInput required label="Received Amount:" control={control} name="receivedAmount" error={errors.receivedAmount?.message} />}
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}